export default __webpack_public_path__ + "static/media/branding-logo.14a81c9c.svg";